import { combineReducers } from '@reduxjs/toolkit';
import { configSlice } from 'forms-ai-lib/internal/reducers/config';
import { customerAgentActionCreatorSlice } from 'forms-ai-lib/internal/reducers/customerAgentActionCreatorSlice';
export const rootReducer = combineReducers({
  config: configSlice.reducer,
  customerAgentActionCreator: customerAgentActionCreatorSlice.reducer
});